import React, { useState, useContext, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Context } from "../../../../../Store";
import callAPI from "../../../../../api/apiCaller";
import Loading from "../../../../../common/Loading";
import Pills from "../../../../../common/Pills";
import Tabs from "../../../../../common/Tabs";
import { PillsContainer } from "../ProgramConnections/ProgramConnection/ConnectionProfile/styles";
import ProgramInBounds from "../ProgramInBounds";
import ProgramOutBonds from "../ProgramOutBounds";
import { ProgramLoaderContainer } from "../ProgramOutBounds/style";
import { OpenNetworkProgramTabs } from "../ProgramRequests/config";
import Modal from "../../../../../common/Modal";
import {
  CardsWrapper,
  RequestListContainer,
  Requestcontainer,
  TabsContainer,
  SearchBoxFilterContainerOuter,
  FilterOuter,
} from "./styles";
import {
  SearchBoxFilterContainer,
  SearchParticipantsWrapper,
  FilterOption,
  FilterText,
  FilterOptions,
  FilterHeadText,
  FilterBy,
  FilterLabel,
  FilterLabelText,
  FilterClear,
  DateInputs,
  FilterButtons,
  ApplyButton,
  ResetButton,
} from "../../../Activity/ActivityContent/styles";
import ActionMenu from "../../../../../common/ActionMenu";
import { getUnacceptedMeetingsCount } from "../../../../../Store/ProgramMeetingCount/accessors";
import Icon from "../../../../../common/Icon";
import TextInput from "../../../../../common/TextInput";
import EnhancedDateRangePicker from "../../../../../common/DatePicker";

function RequestList() {
  const [program, setProgram] = useState(null);
  const filterRef = useRef(null);
  const [programMeetingCount, setProgramMeetingCount] = useState([]);
  const [MeetingTabCount, setMeetingTabCount] = useState([]);
  const params = useParams();
  const [currentTab, setCurrentTab] = useState("Upcoming");
  const { state, dispatch } = useContext(Context);
  const [showUnfulfilled, setShowUnfulfilled] = useState(false);
  const [countUnfulfilled, setCountUnfulfilled] = useState(
    getUnacceptedMeetingsCount(state).count
  );
  const [searchParticipant, setSearchParticipant] = useState("");
  const [filterOptions, setFilterOptions] = useState(false);
  const [programTitle, setProgramTitle] = useState("");
  const [dateRange, setDateRange] = useState({ from: null, to: null });
  const [refreshOnApply, setRefreshOnApply] = useState(false);

  function retrieveProgramInformation() {
    setProgram(null);
    params.selectedProgram &&
      callAPI(dispatch, "getProgramInformation", {
        id: params.selectedProgram,
      }).then((info) => {
        setProgram(info.data);
        if (info?.data.role === "mentor") {
          setCurrentTab("Requests");
        } else if (info?.data.role === "mentor_manager") {
          setCurrentTab("Requests");
        }
      });
  }

  const applyFilters = () => {
    setRefreshOnApply(!refreshOnApply);
  };

  const resetFilters = () => {
    setProgramTitle("");
    setDateRange({ from: null, to: null });
    setRefreshOnApply(!refreshOnApply);
  };

  function specificProgramMeetingsStatistics() {
    callAPI(dispatch, "specificProgramMeetingsCount", {
      id: params.selectedProgram,
    }).then((info) => {
      setProgramMeetingCount(info.data);
    });
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setFilterOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function allProgramMeetingStatistics() {
    callAPI(dispatch, "allProgramsMeetingsCount", {}).then((info) => {
      setMeetingTabCount(info.data);
      setCountUnfulfilled(info.data?.unfulfilledRequests);
    });
  }

  React.useEffect(() => {
    if (params.selectedProgram) {
      specificProgramMeetingsStatistics();
      retrieveProgramInformation();
    } else {
      allProgramMeetingStatistics();
    }
    return () => {
      setProgram(null);
    };
  }, []);

  let options = "";
  if (params.selectedProgram) {
    if (program?.role === "mentor") {
      options = OpenNetworkProgramTabs["OPEN_NETWORK"]["mentor_dashboard"];
    }
    if (program?.role === "mentee") {
      options = OpenNetworkProgramTabs["OPEN_NETWORK"]["mentee_dashboard"];
    }
    if (program?.role === "mentor_manager") {
      options = OpenNetworkProgramTabs["OPEN_NETWORK"]["mentor_manager"];
    }
  } else options = OpenNetworkProgramTabs["OPEN_NETWORK"]["dashboard"];

  const RenderComponent = (currentTab) => {
    // eslint-disable-next-line default-case
    switch (currentTab) {
      case "Requests":
        return (
          <ProgramInBounds
            refreshOnApply={refreshOnApply}
            dateRange={dateRange}
            searchParticipant={searchParticipant}
            programTitle={programTitle}
            currentTab={currentTab}
            requests={true}
            allProgramMeetingStatistics={allProgramMeetingStatistics}
            specificProgramMeetingsStatistics={
              specificProgramMeetingsStatistics
            }
          />
        );
      case "Upcoming":
        return (
          <ProgramOutBonds
            refreshOnApply={refreshOnApply}
            dateRange={dateRange}
            programTitle={programTitle}
            searchParticipant={searchParticipant}
            isUpcoming={true}
            currentTab={currentTab}
            allProgramMeetingStatistics={allProgramMeetingStatistics}
            specificProgramMeetingsStatistics={
              specificProgramMeetingsStatistics
            }
          />
        );
      case "Past":
        return (
          <ProgramOutBonds
            refreshOnApply={refreshOnApply}
            dateRange={dateRange}
            programTitle={programTitle}
            searchParticipant={searchParticipant}
            currentTab={currentTab}
            isPast={true}
            isUnfulfilled={false}
            allProgramMeetingStatistics={allProgramMeetingStatistics}
            specificProgramMeetingsStatistics={
              specificProgramMeetingsStatistics
            }
          />
        );
      case "unfulfilled":
        return (
          <ProgramOutBonds
            currentTab={currentTab}
            isPast={true}
            dateRange={dateRange}
            programTitle={programTitle}
            searchParticipant={searchParticipant}
            isUnfulfilled={true}
            allProgramMeetingStatistics={allProgramMeetingStatistics}
            specificProgramMeetingsStatistics={
              specificProgramMeetingsStatistics
            }
          />
        );
      case "Archived":
        return (
          <ProgramInBounds
            isArchive={true}
            dateRange={dateRange}
            programTitle={programTitle}
            searchParticipant={searchParticipant}
            currentTab={currentTab}
            allProgramMeetingStatistics={allProgramMeetingStatistics}
            specificProgramMeetingsStatistics={
              specificProgramMeetingsStatistics
            }
          />
        );
    }
  };

  if (!options?.length) {
    return (
      <ProgramLoaderContainer>
        {" "}
        <Loading loadingItem="" />{" "}
      </ProgramLoaderContainer>
    );
  }
  return (
    <>
      {options.length && (
        <>
          <Requestcontainer>
            <RequestListContainer
              margin={true}
              isBackground={params.selectedProgram}
            >
              {params.selectedProgram ? (
                <PillsContainer meetings={true} isConnection={true}>
                  <Pills
                    meetings={true}
                    isWidth={true}
                    value={currentTab}
                    setValue={setCurrentTab}
                    options={options}
                    count={programMeetingCount}
                  />
                </PillsContainer>
              ) : (
                <>
                  <TabsContainer>
                    <Tabs
                      value={currentTab}
                      setValue={(newTab) => {
                        setCurrentTab(newTab);
                      }}
                      options={options}
                      count={MeetingTabCount}
                    />
                    <ActionMenu
                      onClick={setShowUnfulfilled}
                      count={countUnfulfilled}
                    />
                  </TabsContainer>
                  <SearchBoxFilterContainerOuter>
                    <SearchBoxFilterContainer>
                      <SearchParticipantsWrapper>
                        <Icon type="search" />
                        <TextInput
                          placeholder="Search"
                          value={searchParticipant}
                          setValue={setSearchParticipant}
                          isSearch={true}
                        />
                      </SearchParticipantsWrapper>
                      <FilterOuter ref={filterRef}>
                        <FilterOption
                          onClick={() => setFilterOptions(!filterOptions)}
                        >
                          <Icon type="filter" />
                          <FilterText>Filter</FilterText>
                        </FilterOption>
                        {filterOptions && (
                          <FilterOptions>
                            <FilterHeadText>Filter By</FilterHeadText>
                            <FilterBy>
                              <FilterLabel>
                                <FilterLabelText>Program Title</FilterLabelText>
                                <FilterClear
                                  onClick={() => setProgramTitle("")}
                                >
                                  Clear
                                </FilterClear>
                              </FilterLabel>
                              <TextInput
                                maxWidth={"93%"}
                                isFilter={true}
                                placeholder="Search by name"
                                value={programTitle}
                                setValue={setProgramTitle}
                              />
                            </FilterBy>
                            <FilterBy>
                              <FilterLabel>
                                <FilterLabelText>Date Range</FilterLabelText>
                                <FilterClear
                                  onClick={() =>
                                    setDateRange({ from: null, to: null })
                                  }
                                >
                                  Clear
                                </FilterClear>
                              </FilterLabel>
                              <DateInputs>
                                <EnhancedDateRangePicker
                                  dateRange={dateRange}
                                  setDateRange={setDateRange}
                                />
                              </DateInputs>
                            </FilterBy>
                            <FilterButtons>
                              <ResetButton onClick={() => resetFilters()}>
                                Reset All
                              </ResetButton>
                              <ApplyButton onClick={() => applyFilters()}>
                                Apply Filter
                              </ApplyButton>
                            </FilterButtons>
                          </FilterOptions>
                        )}
                      </FilterOuter>
                    </SearchBoxFilterContainer>
                  </SearchBoxFilterContainerOuter>
                </>
              )}
              <CardsWrapper isHome={!params.selectedProgram}>
                {RenderComponent(currentTab)}
              </CardsWrapper>
            </RequestListContainer>
            {/* {currentTab==='Inbound' &&  <NewRequest />} */}
            {showUnfulfilled && (
              <Modal
                title={"Unaccepted Meetings"}
                onClose={() => setShowUnfulfilled(false)}
                isHeight={"70%"}
                actions={[
                  {
                    text: "Cancel",
                    variant: "pending",
                    isNotRound: true,
                    isTask: true,
                    isCenter: true,
                    onClick: () => {
                      setShowUnfulfilled(false);
                    },
                  },
                ]}
              >
                <ProgramOutBonds
                  currentTab={currentTab}
                  isPast={true}
                  isUnfulfilled={true}
                  dateRange={dateRange}
                  programTitle={programTitle}
                  searchParticipant={searchParticipant}
                  allProgramMeetingStatistics={allProgramMeetingStatistics}
                  specificProgramMeetingsStatistics={
                    specificProgramMeetingsStatistics
                  }
                />
              </Modal>
            )}
          </Requestcontainer>
        </>
      )}
    </>
  );
}

export default RequestList;
